import * as React from "react"
import { Link, graphql } from "gatsby"
import * as styles from "@/styles/pages/index.module.scss";

import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = ({ data }) => (
  <Layout sidebar>
    <Seo title="玄関" />
    <p>木瓜丸です。気の赴くままに何かを作っています。<br />このサイトにはブログや過去に作ったものを載せています。よかったら見ていってください。</p>
    <div className={styles.blogList}>
      { data.allMarkdownRemark.nodes.map(page => (
        <div className={styles.item}>
          <Link to={ `/blog${page.fields.slug}` }>
            <h3 className={styles.title}>{ page.frontmatter.title }</h3>
            <span className={styles.date}>{ page.frontmatter.date }</span>
          </Link>
        </div>
      )) }
    </div>
  </Layout>
)

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      filter: { fields: { draft: { eq: false } } }
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
          date(formatString: "YYYY年 M月 D日")
        }
      }
    }
  }
`

export default IndexPage
